import { useContext, useEffect, useMemo, useState } from 'react';
import { AppContext } from 'App';
import { isDynamicModificationEnabled } from 'lib/useDynamicModificationRules';
import inspectionsService from './inspectionsService';

const EMPTY_SUMMARY = { asked: [], skipped: [] };

/**
 * What dynamic modification rules did to one inspection: the questions they
 * skipped, and the stage each asked question ran at.
 */
export default function useInspectionDynamicModification(inspectionId) {
  const { appState } = useContext(AppContext);
  const isEnabled = isDynamicModificationEnabled(appState);
  const [summary, setSummary] = useState(EMPTY_SUMMARY);

  useEffect(() => {
    if (!isEnabled || !inspectionId) return;
    let isMounted = true;
    inspectionsService
      .getInspectionDynamicModification(inspectionId)
      .then((loaded) => isMounted && setSummary(loaded))
      .catch(() => isMounted && setSummary(EMPTY_SUMMARY));
    return () => {
      isMounted = false;
    };
  }, [isEnabled, inspectionId]);

  const askedById = useMemo(
    () => new Map(summary.asked.map((asked) => [`${asked.questionId}`, asked])),
    [summary.asked],
  );

  return {
    skipped: summary.skipped,
    stageOf: (questionId) => askedById.get(`${questionId}`) || null,
  };
}
